<!--
 * @Author: your name
 * @Date: 2022-02-28 13:48:40
 * @LastEditTime: 2022-02-28 14:26:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \xingmahui_front\src\components\common\loginPop\index.vue
-->
<template>
  <van-dialog
    v-model="showTip"
    :title="tipstr"
    :before-close="beforeClose"
    :confirmButtonText='okText'
    :cancelButtonText='closeText'
    :message='messageText'
    :show-cancel-button="showCancelButton"
    className='dialog'
    message-align='left'
    allow-Html='true'
  >
  </van-dialog>
</template>
<script>
export default {
  name: "logintip",
  data() {
    return {
      showTip:this.show
    };
  },
 
  watch: {
    show(val) {
      this.showTip = val
    }
  },
  props: {
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    tipstr: {
      type: String,
      default: "立即注册星妈会享受定制化育儿服务",
    },
    okText:{
      type: String,
      default: "确认",
    },
    closeText:{
      type: String,
      default: "取消",
    },
    messageText:{
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    beforeClose(action, done) {
      if (action === "confirm") {
        this.$emit("confirmWay");
        done();
      } else if (action === "cancel") {
        this.$emit("cancleWay");
        done();
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .dialog{
    border-radius: 8px;
    width: 280px;
    height: 134px;
  }
  /deep/ .van-dialog__confirm, .van-dialog__confirm:active{
    background: #E9AC22;
    color: #fff;
    font-size: 18px;
  }
  /deep/ .van-dialog__content{
    min-height: 0;
  }
  /deep/ .van-dialog__message{
    color: #888;
    font-weight: 500;
    font-size: 15px;
    margin: 25px 32px;
    padding: 0;
    // text-align: left;
  }
  /deep/ .van-dialog__cancel{
    font-size: 18px;
  }
</style>
